import React, {useCallback} from 'react';
import Button from "@mui/material/Button";

import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import SaveIcon from '@mui/icons-material/Save';
import axios from "axios";
import * as yup from 'yup';
import {Stack} from "@mui/material";
import {Formik} from 'formik';
import {dateValueFormatter, dateValueGetter, FormDialog, toast} from "@lb/mlib-components";
import ConfirmModal from "../ui/ConfirmModal";

const formId = 'edit-holiday-form';

const validationSchema = yup.object({
    holiday: yup.date().required('Holiday is required'),
    title: yup.string('Enter title').min(1, 'Title should be of minimum 1 character long')
        .required('Title is required'),

});

export default function EditHolidayForm(props) {

    const initialValues = {
        title: props.holiday?.title || '',
        holiday: props.holiday?.holiday || '',
    };

    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = React.useState(false);

    const onConfirm = useCallback(() => {

        return axios.delete('/holidays/' + props.holiday?.holiday)
            .then(() => {
                toast.success('Your request has been successfully sent.');
            }).finally(() => {
                props.handleClose();
                setOpenConfirmationModal(false)
            })

    }, [props]);


    return (
        <FormDialog
            title={`Edit ${dateValueFormatter(dateValueGetter(props.holiday?.holiday), 'ccc, dd LLL')}`}
            open
            onClose={props.handleClose}
            active={openBackdrop}
            onDelete={() => setOpenConfirmationModal(true)}
            deleteLabel="Delete Holiday"
            actions={
                <Button
                    variant="contained"
                    type="submit"
                    form={formId}
                    aria-label="save"
                    startIcon={<SaveIcon/>}
                >
                    Save
                </Button>
            }
        >
            <Formik
                initialValues={initialValues} enableReinitialize validationSchema={validationSchema}

                onSubmit={async (values) => {
                    setOpenBackdrop(true);


                    let data = {
                            title: values.title,
                        }
                    ;


                    axios.put(`/holidays/${props.holiday?.holiday}`,
                        data).then(() => {

                        toast.success('Your request has been successfully sent.');

                        props.handleClose();

                    }).finally(() => {
                        setOpenBackdrop(false);

                    });


                }}
            >
                {propsFormik => (
                    <Box component="form" id={formId} onSubmit={propsFormik.handleSubmit}>
                        <Stack spacing={2} direction="row" sx={{
                            alignItems: "center"
                        }}>
                            <TextField
                                title="title"
                                fullWidth
                                id="title"
                                name="title"
                                label="Title"
                                autoFocus
                                value={propsFormik.values.title}
                                onChange={propsFormik.handleChange}
                                error={propsFormik.touched.title && Boolean(propsFormik.errors.title)}
                                helperText={propsFormik.touched.title && propsFormik.errors.title}
                            />
                        </Stack>
                    </Box>
                )}
            </Formik>
            <ConfirmModal open={openConfirmationModal}
                          mainTitle={'Delete Holiday'}
                          title="Please confirm the deletion of this holiday."
                          onClose={() => setOpenConfirmationModal(false)}
                          onConfirm={onConfirm}
            />
        </FormDialog>
    );
}
